import { Link } from "react-router-dom";
import { boards } from "@/mocks/boards";
import { boardThemes } from "@/utils/site";

const iconTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function BoardGrid() {
  return (
    <section id="boards" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">BOARDS</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">板块分类</h2>
            <p className="mt-2 text-sm text-foreground-600">
              8 个讨论板块各聊各的，先找到你的主场，再慢慢变成常驻瓜友。
            </p>
          </div>
          <Link
            to="/topics"
            className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-800"
          >
            进入讨论版
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {boards.map((board) => {
            const theme = boardThemes[board.accent] ?? boardThemes.primary;
            return (
              <Link
                key={board.id}
                to={`/topics?board=${board.id}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${iconTone[board.accent]}`}
                >
                  <i className={board.icon} />
                </span>
                <h3 className="mt-4 flex items-center gap-1.5 text-base font-semibold text-foreground-950">
                  {board.name}
                  <i className="ri-arrow-right-up-line text-sm text-foreground-300 transition-colors group-hover:text-primary-600" />
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {board.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>共 {board.topics.toLocaleString()} 帖</span>
                  <span className={`rounded-md px-2 py-0.5 ${theme.chip}`}>
                    今日 +{board.todayPosts}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}